import * as React from "react"
import { Link } from "react-router-dom"
import Table from 'react-bootstrap/Table';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";

const Relics = () => (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    alt=""
    src="/relicsBanner.jpg"
  quality="40"
    formats={["auto", "webp", "avif"]}/>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>

<Typography variant="h1" style={{textAlign: "center"}}>2023年農曆新年佛舍利展</Typography>
<Typography variant="h2" style={{textAlign: "center"}}>新年伊始獲得佛陀的無上加持!</Typography><br/>
<Table style={{tableLayout: "fixed"}}><tbody>
<tr><td></td><td colSpan={3}>
<Typography variant="body1" style={{textAlign: "center"}}>
<b>2023年1月21日星期六-1月29日星期天，上午10點至晚上7點</b><br/>
溈山寺 （7732 Emerson Place Rosemead, CA 91770） 和<br/>
法藏寺（3201 Ulloa Street San Francisco, CA 94116）<br/><br/>
靜坐時間：<br/>
上午9點-10點和下午7點到8點：我們的僧人帶領與舍利子靜坐 <br/>
* 可提供靜坐指導
</Typography></td><td></td></tr>
      </tbody>
    </Table>
<a href="/mahaStupa.png"><img src="/mahaStupa.png" width="100%" /></a>
  </Layout>
  </>
)

export default Relics
